import * as actionTypes from './actionTypes';

interface State {
  data: any[];
  isFetching: boolean;
  error: boolean;
  show: boolean;
  message: string;
  title: string;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false,
  show: false,
  message: '',
  title: ''
}

export const headBand = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FETCH_HEADBAND_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_HEADBAND_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_HEADBAND_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.SHOW_HEADBAND:
      return {
        ...state,
        show:true
      };
    case actionTypes.HIDE_HEADBAND:
      return {
        show: false
      };
    default:
      return state;
  }
}
